import request from './request';

const application_info = {
	async getApplicationInfo(id) {
		const response = await request.get(`/app/application-infos/id?id=${id}`);
		return response;
	},
	async createApplicationInfo(body) {
		const res = await request.post('/app/application-infos', body);
		return res;
	},
	async updateApplicationInfo(id, body) {
		const res = await request.patch(`/app/application-infos/id?id=${id}`, body);
		return res;
	}
};

export default application_info;